import React from 'react';

function MenuCharacter({ type }) {
  // type: 'pig' (Silvester), 'clover' (Neujahr), 'santa' (Weihnachten), 'snowman' (Winter)
  
  const [bubbles, setBubbles] = React.useState([]);
  const bubbleIdRef = React.useRef(0);
  
  // Verschiedene Objekte je nach Charakter
  const getBubbleTypes = () => {
    switch(type) {
      case 'santa': // Weihnachten: Geschenke + O2 Sachen
        return ['gift', 'gift', 'o2logo', 'o2home', 'smartphone', 'gift'];
      case 'snowman': // Winter: Schneeflocken + O2 Sachen
        return ['snowflake', 'snowflake', 'o2logo', 'snowflake', 'wlan', 'snowflake'];
      case 'pig': // Silvester: O2 Mix
        return ['o2home', 'o2logo', 'smartphone', 'wlan', 'sim', 'o2logo'];
      case 'clover': // Neujahr: O2 Mix
        return ['o2logo', 'o2home', 'smartphone', 'sim', 'wlan', 'o2logo'];
      default:
        return ['o2logo'];
    }
  };
  
  React.useEffect(() => {
    const types = getBubbleTypes();
    
    const spawnBubble = () => {
      const id = bubbleIdRef.current++;
      const bubbleType = types[Math.floor(Math.random() * types.length)];
      const bubble = {
        id,
        type: bubbleType,
        size: 22 + Math.random() * 20,
        left: 35 + Math.random() * 30,
        duration: 2.5 + Math.random() * 1.5,
        rotation: Math.random() * 360
      };
      setBubbles(prev => [...prev, bubble]);
      setTimeout(() => {
        setBubbles(prev => prev.filter(b => b.id !== id));
      }, bubble.duration * 1000);
    };
    
    spawnBubble();
    const interval = setInterval(spawnBubble, 600 + Math.random() * 600);
    return () => clearInterval(interval);
  }, [type]);
  
  // Bubble-Icon rendern
  const renderBubbleContent = (bubbleType, size) => {
    const iconSize = size * 0.7;
    
    switch(bubbleType) {
      case 'o2logo':
        return (
          <g>
            <circle cx="15" cy="15" r="12" fill="rgba(0,180,255,0.2)" stroke="rgba(0,200,255,0.6)" strokeWidth="1.5"/>
            <text x="8" y="19" fill="rgba(0,220,255,0.95)" fontSize="9" fontWeight="bold">O₂</text>
          </g>
        );
      case 'o2home':
        return (
          <g>
            <circle cx="15" cy="15" r="13" fill="rgba(0,180,255,0.15)" stroke="rgba(0,200,255,0.5)" strokeWidth="1"/>
            <path d="M8 16 L15 9 L22 16 L22 22 L8 22 Z" fill="rgba(0,200,255,0.8)" stroke="rgba(0,220,255,1)" strokeWidth="0.8"/>
            <rect x="12" y="17" width="6" height="5" fill="rgba(255,255,255,0.4)"/>
            <text x="6" y="28" fill="rgba(0,220,255,0.9)" fontSize="5" fontWeight="bold">my Home</text>
          </g>
        );
      case 'smartphone':
        return (
          <g>
            <rect x="9" y="5" width="12" height="20" rx="2" fill="#1f2937" stroke="rgba(0,200,255,0.6)" strokeWidth="1"/>
            <rect x="10" y="7" width="10" height="14" rx="1" fill="rgba(0,180,255,0.4)"/>
            <circle cx="15" cy="23" r="1.5" fill="rgba(0,200,255,0.6)"/>
            <text x="11" y="15" fill="white" fontSize="4" fontWeight="bold">O₂</text>
          </g>
        );
      case 'wlan':
        return (
          <g>
            <circle cx="15" cy="15" r="12" fill="rgba(0,180,255,0.15)"/>
            <path d="M15 22 L15 20" stroke="rgba(0,220,255,1)" strokeWidth="2" strokeLinecap="round"/>
            <path d="M10 17 Q15 12 20 17" fill="none" stroke="rgba(0,220,255,0.9)" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M7 14 Q15 6 23 14" fill="none" stroke="rgba(0,220,255,0.7)" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M4 11 Q15 0 26 11" fill="none" stroke="rgba(0,220,255,0.5)" strokeWidth="1.5" strokeLinecap="round"/>
          </g>
        );
      case 'sim':
        return (
          <g>
            <rect x="7" y="5" width="16" height="20" rx="2" fill="rgba(255,215,0,0.8)" stroke="rgba(255,180,0,1)" strokeWidth="1"/>
            <path d="M20 5 L23 8 L23 5 Z" fill="rgba(0,0,0,0.2)"/>
            <rect x="10" y="12" width="10" height="8" rx="1" fill="rgba(200,160,0,0.6)"/>
            <line x1="12" y1="12" x2="12" y2="20" stroke="rgba(150,120,0,0.5)" strokeWidth="0.5"/>
            <line x1="15" y1="12" x2="15" y2="20" stroke="rgba(150,120,0,0.5)" strokeWidth="0.5"/>
            <line x1="18" y1="12" x2="18" y2="20" stroke="rgba(150,120,0,0.5)" strokeWidth="0.5"/>
          </g>
        );
      case 'gift':
        return (
          <g>
            <rect x="6" y="10" width="18" height="15" rx="2" fill="#dc2626"/>
            <rect x="6" y="10" width="18" height="4" rx="1" fill="#fbbf24"/>
            <rect x="13" y="10" width="4" height="15" fill="#fbbf24"/>
            <path d="M10 10 Q15 4 15 10" fill="none" stroke="#fbbf24" strokeWidth="2"/>
            <path d="M20 10 Q15 4 15 10" fill="none" stroke="#fbbf24" strokeWidth="2"/>
          </g>
        );
      case 'snowflake':
        return (
          <g>
            <line x1="15" y1="3" x2="15" y2="27" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="3" y1="15" x2="27" y2="15" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="6" y1="6" x2="24" y2="24" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
            <line x1="24" y1="6" x2="6" y2="24" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="15" cy="15" r="3" fill="rgba(200,230,255,0.8)"/>
            <circle cx="15" cy="6" r="1.5" fill="rgba(200,230,255,0.6)"/>
            <circle cx="15" cy="24" r="1.5" fill="rgba(200,230,255,0.6)"/>
            <circle cx="6" cy="15" r="1.5" fill="rgba(200,230,255,0.6)"/>
            <circle cx="24" cy="15" r="1.5" fill="rgba(200,230,255,0.6)"/>
          </g>
        );
      default:
        return (
          <g>
            <circle cx="15" cy="15" r="12" fill="rgba(0,180,255,0.15)" stroke="rgba(0,200,255,0.5)" strokeWidth="1.5"/>
            <text x="8" y="19" fill="rgba(0,220,255,0.9)" fontSize="8" fontWeight="bold">O₂</text>
          </g>
        );
    }
  };
  
  // Schneemann SVG
  // Moderner Schneemann SVG - minimalistisch, O2 Style
  const SnowmanSVG = () => (
    <svg viewBox="0 0 80 100" className="menu-character-svg">
      <defs>
        <linearGradient id="snowmanBody" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#f0f9ff"/>
          <stop offset="100%" stopColor="#e0f2fe"/>
        </linearGradient>
        <linearGradient id="snowmanShadow" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="rgba(56,189,248,0.1)"/>
          <stop offset="100%" stopColor="rgba(14,165,233,0.2)"/>
        </linearGradient>
        <filter id="snowGlow">
          <feGaussianBlur stdDeviation="1" result="blur"/>
          <feMerge>
            <feMergeNode in="blur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Körper - moderne gerundete Formen */}
      <ellipse cx="40" cy="78" rx="26" ry="18" fill="url(#snowmanBody)" filter="url(#snowGlow)"/>
      <ellipse cx="34" cy="76" rx="10" ry="5" fill="url(#snowmanShadow)"/>
      
      <ellipse cx="40" cy="52" rx="20" ry="16" fill="url(#snowmanBody)" filter="url(#snowGlow)"/>
      <ellipse cx="34" cy="50" rx="7" ry="4" fill="url(#snowmanShadow)"/>
      
      {/* Kopf */}
      <circle cx="40" cy="26" r="16" fill="url(#snowmanBody)" filter="url(#snowGlow)"/>
      <ellipse cx="34" cy="22" rx="5" ry="3" fill="url(#snowmanShadow)"/>
      
      {/* Moderne Augen - O2 Blau */}
      <circle cx="34" cy="23" r="4" fill="#0284c7"/>
      <circle cx="46" cy="23" r="4" fill="#0284c7"/>
      <circle cx="35" cy="22" r="1.5" fill="white"/>
      <circle cx="47" cy="22" r="1.5" fill="white"/>
      
      {/* Karotten-Nase - vereinfacht */}
      <path d="M40 27 L50 29 L40 31 Z" fill="#fb923c"/>
      
      {/* Lächeln */}
      <path d="M34 34 Q40 38 46 34" stroke="#0284c7" strokeWidth="2" fill="none" strokeLinecap="round"/>
      
      {/* Moderner Hut - O2 Blau */}
      <rect x="26" y="4" width="28" height="14" rx="4" fill="#0369a1"/>
      <rect x="22" y="16" width="36" height="5" rx="2" fill="#0284c7"/>
      {/* Hutband mit Glow */}
      <rect x="28" y="7" width="4" height="10" rx="1" fill="#38bdf8"/>
      
      {/* Schal - O2 Cyan Gradient */}
      <path d="M24 40 Q40 46 56 40" fill="#06b6d4" stroke="#0891b2" strokeWidth="1"/>
      <rect x="50" y="40" width="8" height="16" rx="3" fill="#06b6d4"/>
      <path d="M50 48 L58 48" stroke="#0891b2" strokeWidth="1"/>
      <path d="M50 52" stroke="#0891b2" strokeWidth="1"/>
      
      {/* Knöpfe - O2 Blau */}
      <circle cx="40" cy="50" r="3" fill="#0284c7"/>
      <circle cx="40" cy="60" r="3" fill="#0284c7"/>
      <circle cx="40" cy="70" r="3" fill="#0284c7"/>
      
      {/* Arme - schlank und modern */}
      <path d="M18 52 L6 42" stroke="#78716c" strokeWidth="3" strokeLinecap="round"/>
      <path d="M62 52 L74 42" stroke="#78716c" strokeWidth="3" strokeLinecap="round"/>
      <circle cx="6" cy="42" r="3" fill="#0ea5e9"/>
      <circle cx="74" cy="42" r="3" fill="#0ea5e9"/>
    </svg>
  );
  
  // Schwein SVG
  const PigSVG = () => (
    <svg viewBox="0 0 80 90" className="menu-character-svg">
      <ellipse cx="40" cy="55" rx="28" ry="25" fill="#fda4af"/>
      <ellipse cx="40" cy="60" rx="20" ry="18" fill="#fecdd3" opacity="0.5"/>
      <ellipse cx="22" cy="78" rx="8" ry="10" fill="#fda4af"/>
      <ellipse cx="58" cy="78" rx="8" ry="10" fill="#fda4af"/>
      <ellipse cx="22" cy="85" rx="6" ry="4" fill="#fb7185"/>
      <ellipse cx="58" cy="85" rx="6" ry="4" fill="#fb7185"/>
      <ellipse cx="40" cy="28" rx="22" ry="20" fill="#fda4af"/>
      <ellipse cx="22" cy="12" rx="10" ry="12" fill="#fda4af"/>
      <ellipse cx="58" cy="12" rx="10" ry="12" fill="#fda4af"/>
      <ellipse cx="22" cy="14" rx="6" ry="7" fill="#fb7185" opacity="0.5"/>
      <ellipse cx="58" cy="14" rx="6" ry="7" fill="#fb7185" opacity="0.5"/>
      <ellipse cx="40" cy="35" rx="12" ry="9" fill="#fb7185"/>
      <ellipse cx="36" cy="35" rx="3" ry="3.5" fill="#881337"/>
      <ellipse cx="44" cy="35" rx="3" ry="3.5" fill="#881337"/>
      <ellipse cx="32" cy="24" rx="5" ry="6" fill="white"/>
      <ellipse cx="48" cy="24" rx="5" ry="6" fill="white"/>
      <circle cx="33" cy="25" r="3" fill="#1f2937"/>
      <circle cx="49" cy="25" r="3" fill="#1f2937"/>
      <circle cx="34" cy="24" r="1.2" fill="white"/>
      <circle cx="50" cy="24" r="1.2" fill="white"/>
      <ellipse cx="40" cy="42" rx="5" ry="4" fill="#881337" opacity="0.7"/>
      <path d="M66 55 Q74 50 76 55 Q78 62 74 65 Q70 68 72 60" stroke="#fb7185" strokeWidth="3" fill="none" strokeLinecap="round"/>
      <g transform="translate(32, -2) scale(0.5)">
        <ellipse cx="10" cy="10" rx="8" ry="10" fill="#22c55e"/>
        <ellipse cx="20" cy="10" rx="8" ry="10" fill="#16a34a"/>
        <ellipse cx="10" cy="20" rx="8" ry="10" fill="#16a34a"/>
        <ellipse cx="20" cy="20" rx="8" ry="10" fill="#22c55e"/>
        <rect x="13" y="25" width="4" height="10" fill="#15803d" rx="2"/>
      </g>
    </svg>
  );
  
  // Kleeblatt SVG
  const CloverSVG = () => (
    <svg className="menu-character-svg" viewBox="0 0 60 70">
      <defs>
        <linearGradient id="menuCloverGreen1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#4ade80"/>
          <stop offset="100%" stopColor="#22c55e"/>
        </linearGradient>
        <linearGradient id="menuCloverGreen2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#22c55e"/>
          <stop offset="100%" stopColor="#16a34a"/>
        </linearGradient>
      </defs>
      <ellipse cx="18" cy="18" rx="14" ry="16" fill="url(#menuCloverGreen1)"/>
      <ellipse cx="42" cy="18" rx="14" ry="16" fill="url(#menuCloverGreen2)"/>
      <ellipse cx="18" cy="38" rx="14" ry="16" fill="url(#menuCloverGreen2)"/>
      <ellipse cx="42" cy="38" rx="14" ry="16" fill="url(#menuCloverGreen1)"/>
      <rect x="27" y="50" width="6" height="18" fill="#15803d" rx="3"/>
      <circle cx="30" cy="28" r="8" fill="rgba(255,255,255,0.2)"/>
      <ellipse cx="22" cy="20" rx="3" ry="4" fill="rgba(255,255,255,0.15)"/>
      <ellipse cx="38" cy="20" rx="3" ry="4" fill="rgba(255,255,255,0.15)"/>
    </svg>
  );
  
  // Weihnachtsmann SVG
  // Moderner Weihnachtsmann SVG - minimalistisch, O2 Style
  const SantaSVG = () => (
    <svg className="menu-character-svg" viewBox="0 0 70 90">
      <defs>
        <linearGradient id="menuSantaCoat" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ef4444"/>
          <stop offset="100%" stopColor="#dc2626"/>
        </linearGradient>
        <linearGradient id="menuSantaSkin" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#fef3c7"/>
          <stop offset="100%" stopColor="#fde68a"/>
        </linearGradient>
        <linearGradient id="menuSantaBeard" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff"/>
          <stop offset="100%" stopColor="#f1f5f9"/>
        </linearGradient>
        <filter id="santaGlow">
          <feGaussianBlur stdDeviation="0.5" result="blur"/>
          <feMerge>
            <feMergeNode in="blur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Schatten */}
      <ellipse cx="35" cy="88" rx="22" ry="4" fill="rgba(0,0,0,0.1)"/>
      
      {/* Körper - moderner */}
      <ellipse cx="35" cy="62" rx="18" ry="20" fill="url(#menuSantaCoat)" filter="url(#santaGlow)"/>
      
      {/* Gürtel - O2 Gold */}
      <rect x="17" y="60" width="36" height="6" fill="#1f2937" rx="2"/>
      <rect x="31" y="58" width="8" height="10" fill="#fbbf24" rx="2"/>
      <rect x="33" y="60" width="4" height="6" fill="#f59e0b" rx="1"/>
      
      {/* Weißer Saum */}
      <ellipse cx="35" cy="80" rx="20" ry="6" fill="url(#menuSantaBeard)"/>
      
      {/* Beine/Stiefel */}
      <ellipse cx="27" cy="86" rx="7" ry="4" fill="#1f2937"/>
      <ellipse cx="43" cy="86" rx="7" ry="4" fill="#1f2937"/>
      
      {/* Kopf */}
      <circle cx="35" cy="28" r="14" fill="url(#menuSantaSkin)" filter="url(#santaGlow)"/>
      
      {/* Bart - modern und weich */}
      <ellipse cx="35" cy="42" rx="12" ry="10" fill="url(#menuSantaBeard)"/>
      <ellipse cx="35" cy="48" rx="8" ry="6" fill="#f8fafc"/>
      <circle cx="29" cy="36" r="4" fill="url(#menuSantaBeard)"/>
      <circle cx="41" cy="36" r="4" fill="url(#menuSantaBeard)"/>
      
      {/* Augen - O2 Blau und freundlich */}
      <ellipse cx="30" cy="26" rx="3" ry="3.5" fill="#0284c7"/>
      <ellipse cx="40" cy="26" rx="3" ry="3.5" fill="#0284c7"/>
      <circle cx="31" cy="25" r="1.2" fill="white"/>
      <circle cx="41" cy="25" r="1.2" fill="white"/>
      
      {/* Nase - rund und freundlich */}
      <circle cx="35" cy="32" r="4" fill="#fca5a5"/>
      
      {/* Wangen */}
      <circle cx="25" cy="32" r="3" fill="#fecaca" opacity="0.6"/>
      <circle cx="45" cy="32" r="3" fill="#fecaca" opacity="0.6"/>
      
      {/* Lächeln */}
      <path d="M30 38 Q35 42 40 38" stroke="#b91c1c" strokeWidth="2" fill="none" strokeLinecap="round"/>
      
      {/* Mütze - modern mit Glow */}
      <path d="M21 22 Q23 6 35 4 Q47 6 49 22" fill="url(#menuSantaCoat)" filter="url(#santaGlow)"/>
      <ellipse cx="35" cy="22" rx="16" ry="4" fill="url(#menuSantaBeard)"/>
      
      {/* Mützen-Zipfel */}
      <path d="M47 18 Q56 12 58 16 Q60 20 56 22" fill="url(#menuSantaCoat)"/>
      <circle cx="58" cy="18" r="5" fill="url(#menuSantaBeard)" filter="url(#santaGlow)"/>
      
      {/* Arme */}
      <ellipse cx="16" cy="55" rx="5" ry="10" fill="url(#menuSantaCoat)"/>
      <ellipse cx="54" cy="55" rx="5" ry="10" fill="url(#menuSantaCoat)"/>
      <circle cx="16" cy="64" r="4" fill="url(#menuSantaBeard)"/>
      <circle cx="54" cy="64" r="4" fill="url(#menuSantaBeard)"/>
    </svg>
  );
  
  const renderCharacter = () => {
    switch(type) {
      case 'snowman': return <SnowmanSVG />;
      case 'pig': return <PigSVG />;
      case 'clover': return <CloverSVG />;
      case 'santa': return <SantaSVG />;
      default: return null;
    }
  };
  
  return (
    <div className={`menu-character menu-${type}`}>
      <div className="menu-character-bubbles">
        {bubbles.map(b => (
          <svg 
            key={b.id} 
            className="menu-o2-bubble" 
            viewBox="0 0 30 30" 
            style={{
              width: b.size, 
              height: b.size, 
              left: `${b.left}%`,
              animationDuration: `${b.duration}s`,
              transform: `rotate(${b.rotation}deg)`
            }}
          >
            {renderBubbleContent(b.type, b.size)}
          </svg>
        ))}
      </div>
      {renderCharacter()}
    </div>
  );
}

export { MenuCharacter };
